import React, { useState, useEffect } from 'react'
import {
    Button, Flex, Table, Badge, Drawer, Input, Divider, Breadcrumb,
    Tag,
    Collapse,
    Modal,
    Row,
    Col,
    Card,
    Avatar,
    Typography,
    Switch,
    Alert
} from 'antd'
import api from '../../../service/axios'
import { useToasts } from 'react-toast-notifications';
import {
    SearchOutlined,
    CalendarOutlined,
    LoadingOutlined,
    ContainerOutlined,
    DownloadOutlined,
    UserOutlined,
    CloseOutlined,
    PhoneOutlined,
    MailOutlined,
    EnvironmentOutlined
} from '@ant-design/icons';
import { userState } from '../../../service/database'
import { useRecoilState } from 'recoil'
import dayjs from 'dayjs';
import LOGO from '../../../images/logomarca_CRQ.png'
import { ARTNova } from './nova'
import { isMobile } from 'react-device-detect';
import PIX from '../../../images/pix.png'
import BOLETO from '../../../images/boleto.png'
import PixCanvas from 'react-qrcode-pix'
import BB from '../../../images/bb.png'


export const ART = (props) => {

    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const { addToast } = useToasts()
    const [arts, setArts] = useState(undefined)
    const [user,] = useRecoilState(userState)
    const [open, setOpen] = useState(false)
    const [open2, setOpen2] = useState(false)
    const [msg, setMsg] = useState('')
    const [selected, setSelected] = useState(undefined)
    const [openTipo, setOpenTipo] = useState(false)
    const [openPay, setOpenPay] = useState(false)
    const [qrcode, setQrcode] = useState('')

    useEffect(() => {
        getArts()
    }, [])

    async function downloadArquivo(path, id, nome) {
        const result = await api.post('/api/v1.0/registrado/file/download', { url: path },
            {
                headers: {
                    'x-access-token': user?.token2
                },
                responseType: 'blob'
            })

        const pdfBlob = new Blob([result.data], { type: "application/pdf" });
        // Cria uma URL temporária para o Blob 
        const url = window.URL.createObjectURL(pdfBlob);
        // Cria         um elemento <a> temporário para iniciar o download 
        const tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", "".concat(nome, '.pdf'));
        // Define o nome de arquivo desejado para o arquivo baixado 
        // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
        document.body.appendChild(tempLink);
        tempLink.click();
        // Limpa os elementos temporários e a URL 
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);
    }


    async function getArts() {
        try {
            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/arts',
                {
                    headers: {
                        'x-access-token': user?.token2
                    }
                }
            )
            console.log(result.data)
            setArts(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }


    async function getArt(id) {
        try {
            setLoading2(true)
            const result = await api.get('/api/v1.0/registrado/art',
                {
                    headers: {
                        'x-access-token': user?.token2
                    },
                    params: {
                        id: id
                    }
                }
            )
            //  console.log(result.data)
            setSelected(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading2(false)
    }



    function renderStatus(item) {
        switch (item.status) {
            case 0: return <Tag color={'blue'}>Solicitada </Tag>;
            case 1: return <Tag color={'cyan'}>Em análise</Tag>;
            case 2: return <Tag color={'geekblue'}>Aguardando pagamento</Tag>;
            case 3: return <Tag color={'success'}>Em emissão</Tag>;
            case 4: return <Tag color={'success'}>Emitida</Tag>;
            case 5: return <Tag color={'success'}>Pendente</Tag>;
            case 6: return <Tag color={'success'}>Recusada</Tag>;
            case 20: return <Tag color={'error'}>Recusada</Tag>;
            default:
                return;
        }
    }

    {
        return <Flex>

            <Alert title={<Flex vertical>
                <div>
                    Prezado(a) Profissional da Química,
                </div>

            </Flex>}
                type='info'
                description={<Flex vertical>

                    <div>
                        Informamos que, em breve, a solicitação de <b>Anotação de Responsabilidade Técnica (ART) </b>
                        estará disponível de forma 100% digital diretamente pelo portal <b>MeuCRQCE</b>.
                    </div>
                    <div style={{ fontSize: '1.2em', marginTop: 10 }}>O que muda com a novidade?</div>

                    <div>
                        <ul>
                            <li><b>Mais agilidade:</b> Processo totalmente online.</li>
                            <li><b>Menos burocracia:</b> Sem necessidade de deslocamento.</li>
                            <li><b>Acesso rápido:</b> Emissão diretamente pela plataforma.</li>
                            <li><b>Histórico seguro:</b> Todos os seus documentos centralizados.</li>
                        </ul>
                    </div>
                </Flex>} />

        </Flex>
    }


    return <Flex vertical gap={10}>
        <Flex justify='space-between'>
            <Breadcrumb items={[
                {
                    title: <Flex align='center' gap={5}>
                        <ContainerOutlined />
                        <Flex>ART</Flex>
                    </Flex>,
                }
            ]} />

            <Flex align='center' gap={25}>


                <Button type='primary' onClick={() => {
                    setOpenTipo(true)
                }}>Nova</Button>


            </Flex>
        </Flex>
        <Flex vertical gap={5}>



            <Table size='small' bordered pagination={false} dataSource={arts} loading={loading} style={{ fontSize: '0.95em' }} styles={{
                content: {
                    fontSize: '0.85em'
                }
            }}>
                <Table.Column hidden={isMobile} title={"Solicitação"} align='center' render={(txt, item, index) => {

                    return <Badge size='small' count={item.msgnaolida} >
                        <span style={{ fontSize: '0.85em' }}>{"".concat(item.id).padStart(4, '0')} </span></Badge>
                }} />
                <Table.Column title={"Data"} align='center' render={(txt, item, index) => {
                    return dayjs(item.createat).format('DD/MM/YYYY HH:mm')
                }} />
                <Table.Column hidden={isMobile} title={"Razão Social"} render={(txt, item, index) => {
                    return item.razao
                }} />
                <Table.Column title={"CNPJ/CPF"} align='center' width={130} render={(txt, item, index) => {
                    return item.cnpj.replaceAll('_', "")
                }} />

                <Table.Column hidden={isMobile} title={"Atividade de Sua Responsabilidade"} render={(txt, item, index) => {
                    return item.descricao
                }} />
                <Table.Column title={"Status"} align='center' render={(txt, item, index) => {
                    return renderStatus(item)
                }} />


                <Table.Column title={""} render={(txt, item, index) => {
                    return <Flex align='center' justify='flex-end'>


                        {item.status === 2 && item.boleto &&
                            <Button
                                type='link'
                                icon={<Avatar size={'small'} src={BB} />}
                                onClick={async () => {
                                    try {
                                        const result = await api.post('/api/v1.0/registrado/boleto', { boletoID: item.boleto.boletoID },
                                            {
                                                headers: {
                                                    'x-access-token': user?.token2
                                                },
                                                responseType: 'blob'
                                            })

                                        const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                                        // Cria uma URL temporária para o Blob 
                                        const url = window.URL.createObjectURL(pdfBlob);
                                        // Cria         um elemento <a> temporário para iniciar o download 
                                        const tempLink = document.createElement("a");
                                        tempLink.href = url;
                                        tempLink.setAttribute("download", "".concat('B', item.boleto.boletoID, '.pdf'));
                                        // Define o nome de arquivo desejado para o arquivo baixado 
                                        // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                                        document.body.appendChild(tempLink);
                                        tempLink.click();
                                        // Limpa os elementos temporários e a URL 
                                        document.body.removeChild(tempLink);
                                        window.URL.revokeObjectURL(url);
                                    } catch (error) {
                                        addToast(error.message, { autoDismiss: true, appearance: 'error' })
                                    }
                                }}></Button>
                        }


                        {
                            item.fileurl && <Button type='link' icon={<DownloadOutlined />}
                                onClick={async () => {
                                    try {
                                        const result = await api.get('/api/v1.0/registrado/art/download',
                                            {
                                                headers: {
                                                    'x-access-token': user?.token2
                                                },
                                                params: {
                                                    id: item.id
                                                },
                                                responseType: 'blob'
                                            }
                                        )
                                        console.log(result.data)
                                        const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                                        // Cria uma URL temporária para o Blob 
                                        const url = window.URL.createObjectURL(pdfBlob);
                                        // Cria         um elemento <a> temporário para iniciar o download 
                                        const tempLink = document.createElement("a");
                                        tempLink.href = url;
                                        tempLink.setAttribute("download", "ART ID: ".concat(item.id, ' - ', item.razao, '.pdf'));
                                        // Define o nome de arquivo desejado para o arquivo baixado 
                                        // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                                        document.body.appendChild(tempLink);
                                        tempLink.click();
                                        // Limpa os elementos temporários e a URL 
                                        document.body.removeChild(tempLink);
                                        window.URL.revokeObjectURL(url);

                                    } catch (error) {
                                        addToast(error, {
                                            autoDismiss: true,
                                            appearance: 'error'
                                        })
                                    }
                                }} />
                        }

                        <Button
                            type='link'
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // console.log(item)
                                setSelected(item)
                                setOpen2(true)
                                getArt(item.id)

                            }}></Button>

                    </Flex>
                }} />

            </Table>
        </Flex>

        {open && <Drawer
            zIndex={9999999}
            size={isMobile ? '100%' : '80%'}
            open={open}
            destroyOnHidden={true}
            title={<Flex justify='space-between'>
                <Flex>REQUERIMENTO DE ANOTAÇÃO DE RESPONSABILIDADE TÉCNICA - ART</Flex>
                <Button type='link' size='small' icon={<CloseOutlined />}
                    onClick={() => {
                        setOpen(false)
                        getArts()
                    }}></Button>
            </Flex>}
            styles={{
                body: {
                    backgroundColor: 'whitesmoke'
                }
            }}
            closable={false}
            onClose={() => { }}
            footer={null}>

            <ARTNova setOpen={setOpen} getArts={getArts} selected={selected} />

        </Drawer>}


        {
            open2 && selected && <Drawer
                size={'80%'}
                open={open2}
                destroyOnHidden={true}
                title={<Flex justify='space-between'><Flex>{"Solicitação: ".concat(selected.id)}</Flex>
                    <Flex gap={5} align='center' style={{ fontWeight: 'normal', fontSize: '0.9em' }}><CalendarOutlined /> {dayjs(selected.createat).format('DD/MM/YYYY HH:mm')}</Flex>
                </Flex>}
                closable={true}
                onClose={() => { setOpen2(false) }}
                footer={
                    <Flex gap={10} justify='flex-end' style={{ marginBottom: 10 }}>
                        <Input placeholder='Sua mensagem' value={msg} onChange={(e) => setMsg(e.target.value)} />
                        <Button
                            disabled={msg.trim().length === 0}
                            loading={selected?.loading} type='primary'
                            onClick={async () => {
                                try {
                                    setSelected({ ...selected, loading: true })
                                    await api.put('/api/v1.0/registrado/art', { autor: 1, msg: msg, id: selected.id },
                                        {
                                            headers: {
                                                'x-access-token': user?.token2
                                            }
                                        }
                                    )
                                    setMsg('')
                                    let aux = { ...selected }
                                    aux.msgs.push({
                                        autor: 1,
                                        msg: msg,
                                        createat: dayjs().format('YYYY-MM-DD HH:mm')
                                    })
                                    setSelected(aux)
                                    setMsg('')

                                } catch (error) {

                                }
                                setSelected({ ...selected, loading: false })
                            }}>
                            Enviar </Button>
                    </Flex>}>

                <Flex vertical gap={5}>

                    <Collapse
                        defaultActiveKey={['1']}
                        items={[
                            {
                                key: '1',
                                label: <span> <b>Descrição da atividade:</b> {selected?.descricao} </span>,
                                children: <Flex justify='space-between'>
                                    <Flex vertical gap={5}>
                                        <Flex justify='space-between'><b>{selected?.razao}</b> </Flex>
                                        <Flex> {selected.cnpj} </Flex>
                                        <Flex style={{ fontStyle: 'italic' }} gap={5}>
                                            <EnvironmentOutlined />
                                            {selected?.endereco}, {selected?.bairro} - {selected?.cidade}</Flex>
                                        {selected?.viapj === 1 && <Flex gap={10}>Via PJ: <Tag color={selected?.viapj === 1 ? 'lime' : 'volcano'}>{selected?.viapj === 1 ? 'Sim' : 'Não'}</Tag> </Flex>}
                                        {selected?.viapj === 1 && <Flex style={{ fontStyle: 'italic' }}>Realizado por: {selected?.realizadorazao}</Flex>}

                                        <Flex gap={5}> <PhoneOutlined /> {selected?.celular}</Flex>
                                        <Flex gap={5}><MailOutlined /> {selected?.email}</Flex>



                                        <Flex gap={5} style={{ marginTop: 5 }} align='center'>
                                            <Flex>Status: </Flex>
                                            <Flex>{renderStatus(selected)}</Flex>

                                            {selected?.status === 2 && selected?.boleto &&
                                                <Button
                                                    type='link'
                                                    icon={<Avatar size={'small'} src={BB} />}
                                                    onClick={async () => {
                                                        try {
                                                            const result = await api.post('/api/v1.0/registrado/boleto', { boletoID: selected?.boleto?.boletoID },
                                                                {
                                                                    headers: {
                                                                        'x-access-token': user?.token2
                                                                    },
                                                                    responseType: 'blob'
                                                                })

                                                            const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                                                            // Cria uma URL temporária para o Blob 
                                                            const url = window.URL.createObjectURL(pdfBlob);
                                                            // Cria         um elemento <a> temporário para iniciar o download 
                                                            const tempLink = document.createElement("a");
                                                            tempLink.href = url;
                                                            tempLink.setAttribute("download", "".concat('B', selected?.boleto?.boletoID, '.pdf'));
                                                            // Define o nome de arquivo desejado para o arquivo baixado 
                                                            // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                                                            document.body.appendChild(tempLink);
                                                            tempLink.click();
                                                            // Limpa os elementos temporários e a URL 
                                                            document.body.removeChild(tempLink);
                                                            window.URL.revokeObjectURL(url);
                                                        } catch (error) {
                                                            addToast(error.message, { autoDismiss: true, appearance: 'error' })
                                                        }
                                                    }}></Button>
                                            }

                                            {selected.fileurl && <Button
                                                type='primary'
                                                style={{ backgroundColor: 'green' }}
                                                size='small' icon={<DownloadOutlined />} onClick={() => {

                                                    downloadArquivo(selected.fileurl, selected.id, "ARTSOL".concat(selected.id))

                                                }}>Baixar ART</Button>
                                            }
                                        </Flex>


                                    </Flex>

                                    <Flex gap={25}>

                                    </Flex>
                                </Flex>,
                            },
                        ]}
                    />

                    <Divider style={{ marginBottom: 10, marginTop: 10 }} />

                    {loading2 && <Flex gap={5} align='center'> <LoadingOutlined /> Aguarde, carregando mensagens... </Flex>}
                    {selected?.msgs?.length === 0 && <Flex style={{ fontStyle: 'italic', color: 'darkgrey' }}> Nada por aqui por enquanto!</Flex>}
                    {selected?.msgs?.map((item2, index) => {
                        return <Flex id={'id:'.concat(index)} style={{ padding: 0, marginTop: 5 }} >
                            <Tag color={item2.autor === 1 ? 'default' : 'blue'} style={{ marginLeft: 10, width: '100%' }}>
                                <Flex vertical>
                                    <Flex justify='space-between' align='center' gap={50}>
                                        <Flex align='center' gap={5}>
                                            {item2.autor === 0 ? <Flex align='center' gap={5}>
                                                <img src={LOGO} height={15} width={15} />
                                                <b> CRQ10/CE </b>
                                            </Flex> :
                                                <Flex align='center' gap={5}>
                                                    <UserOutlined />
                                                    <b> {user?.nome} </b>
                                                </Flex>
                                            }

                                        </Flex>

                                        <Flex style={{ fontSize: '0.8em', fontWeight: 700 }} gap={0}>
                                            {dayjs().format('DD/MM/YYYY') === dayjs(item2.createat).format('DD/MM/YYYY') ? 'Hoje ' : dayjs(item2.createat).format('DD/MM/YY').concat(' ')}
                                            {dayjs(item2.createat).format('HH:mm')}
                                            <Flex>hs </Flex>
                                        </Flex>

                                    </Flex>


                                    <Flex style={{ fontStyle: 'italic', color: '#333232' }}> {item2.msg}</Flex>
                                </Flex>
                            </Tag>
                        </Flex>
                    })}


                </Flex>

            </Drawer>
        }



        <Modal
            centered
            onCancel={() => setOpenTipo(false)}

            styles={{
                body: {
                    backgroundColor: 'whitesmoke',
                    padding: 16
                }
            }}
            title={"Certidão de Anotação de Responsabilidade Técnica"}
            open={openTipo}
            width={1000}
            footer={null}>
            <Row gutter={16}>
                <Col xs={24} md={24}>
                    <div>
                        <span style={{ color: 'blue', fontWeight: 600 }}>Taxa:</span>
                        <span style={{ marginLeft: 5 }}>R$ 93,13</span>

                    </div>
                </Col>
                <Col xs={24} md={24}>
                    <div style={{ marginBottom: 10 }}>
                        <span style={{ color: 'blue', fontWeight: 600 }}>Prazo de análise e expedição:</span>
                        <div style={{ fontSize: '0.95em' }}>O prazo de análise da solicitação da ART é de até 2 (dois) dias úteis. Após emissão,
                            a certidão ficará disponível na plataforma MeuCRQCE para consulta.</div>
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <Card
                        hoverable
                        title={<Flex>
                            ART PF – Autônomo
                        </Flex>}

                        actions={[
                            <Button type='primary' onClick={() => {
                                setSelected({ ispj: 1, viapj: 0, celular: user?.telefone, email: user?.emailprimary, formapagamento: 1 })
                                setOpenTipo(false)
                                setOpen(true)
                            }}>Solicitar</Button>
                        ]}>
                        <Flex style={{ padding: 8 }} wrap>
                            Certifica que um serviço foi realizado por um profissional da Química atuando como autônomo.
                            Representa o registo oficial de execução de serviços avulsos, de projetos específicos ou fornecimento de bens
                            relacionados com a atividade Química por um determinado período. Certidão destinada a profissionais com registro ativo e situação regular no CRQ10/CE.
                        </Flex>
                        <Card.Meta title={<Divider style={{ color: 'red', marginTop: 6, marginBottom: 6 }}>Atenção!</Divider>}
                            description={<ul>
                                <li>Sua emissão está condicionada ao profissional estar em dia com o pagamento da anuidade e taxa correspondente;</li>
                                <li>A emissão da ART PF – Autônomo é individual para cada serviço realizado sob a responsabilidade do profissional da Química.</li>
                            </ul>} />
                    </Card>



                </Col>
                <Col xs={24} md={12}>
                    <Card
                        hoverable
                        title={<Flex>
                            ART PF – Serviço via PJ
                        </Flex>}

                        actions={[
                            <Button type='primary' onClick={() => {
                                setSelected({ ispj: 1, viapj: 1, celular: user?.telefone, email: user?.emailprimary, formapagamento: 1 })
                                setOpenTipo(false)
                                setOpen(true)
                            }}>Solicitar</Button>
                        ]}>
                        <Flex style={{ padding: 8 }} wrap>
                            Certifica que um serviço realizado por uma pessoa jurídica foi efetivado sob a responsabilidade técnica de um
                            profissional da Química habilitado e registrado. Certidão destinada a profissionais e empresas com registro ativo e
                            situação regular no CRQ10/CE.
                        </Flex>
                        <Card.Meta title={<Divider style={{ color: 'red', marginTop: 6, marginBottom: 6 }}>Atenção!</Divider>}
                            description={<ul>
                                <li>Sua emissão está condicionada a ambos (profissional e empresa prestadora dos serviços) estarem em dia com o pagamento das
                                    respectivas anuidades e efetuado o pagamento da taxa correspondente;</li>
                                <li>A emissão da ART PF – Serviço via PJ é individual para cada serviço realizado pela empresa, sob a responsabilidade técnica do profissional da química.</li>
                            </ul>} />
                    </Card>

                </Col>
            </Row>
        </Modal>



        {selected && <Modal
            styles={{
                body: {
                    backgroundColor: 'whitesmoke',
                    padding: 24
                }
            }}
            footer={null}
            centered
            width={550}
            open={openPay}
            onCancel={() => setOpenPay(false)}
            title={<Flex align='center' gap={5}>
                <Flex>Pagamento de ART - Solicitação {selected.id}</Flex>
            </Flex>}>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={24}>
                    <div>
                        <span style={{ color: 'blue', fontWeight: 600 }}>Taxa:</span>
                        <span style={{ marginLeft: 5 }}>R$ 93,13</span>

                    </div>
                </Col>

            </Row>
            <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
                {selected?.formapagamento === 1 && <Col xs={24} md={24} >
                    <Card hoverable
                        title={<Flex vertical
                            style={{ flex: 1, height: '100%' }}>
                            <Flex align='center' gap={5}>
                                <Avatar src={PIX} size={'small'} />
                                <Flex>PIX: mais rapidez e praticidade</Flex>
                            </Flex>

                        </Flex>}>

                        <Flex style={{ textAlign: 'justify' }}>
                            Optar pelo pagamento via PIX oferece mais agilidade em comparação ao boleto bancário. Embora a identificação do
                            pagamento possa não ocorrer de forma instantânea em nosso sistema, a compensação e a confirmação costumam ser
                            significativamente mais rápidas do que as do boleto, permitindo maior celeridade no processamento da sua solicitação.
                        </Flex>

                        <Flex justify='center' style={{ marginBottom: 5, marginTop: 10 }}>
                            <PixCanvas
                                size={100}
                                pixkey='07348139000170'
                                style={{ height: 100, width: 100 }}
                                merchant='CRQX'
                                city='Fortaleza'
                                cep='60025131'
                                code={'ART-SOL-'.concat(selected?.id)}
                                amount={93.13}
                                onLoad={payload => setQrcode(payload)}
                            />
                        </Flex>

                        <Typography.Text copyable={{
                            text: qrcode,
                            tooltips: ['Clique para copiar', 'Copiado com sucesso!'],
                        }}>
                            {qrcode}
                        </Typography.Text>
                        <Divider style={{ marginTop: 8, marginBottom: 8 }} />

                        <Flex justify='space-between' align='center'>
                            <Flex align='center' gap={5} style={{ marginTop: 10, fontSize: '1em' }}>Pagamento já efetuado </Flex>
                            <Switch
                                checked={selected?.pixpago === 1}
                                onChange={async (e) => {
                                    try {
                                        await api.put('/api/v1.0/registrado/art/pix', { pixpago: e === true ? 1 : 0, id: selected.id },
                                            {
                                                headers: {
                                                    'x-access-token': user?.token2
                                                },
                                            })
                                        setSelected({ ...selected, pixpago: e === true ? 1 : 0 })

                                    } catch (error) {

                                    }
                                }} />
                        </Flex>


                    </Card>
                </Col>}
                {selected?.formapagamento === 0 && <Col xs={24} md={24} flex={1}>
                    <Card hoverable
                        title={<Flex vertical >
                            <Flex align='center' gap={5}>
                                <Avatar src={BOLETO} shape='square' size={'small'} />
                                <Flex>Boleto Bancário</Flex>
                            </Flex>

                        </Flex>}
                        style={{ flex: 1, height: '100%' }}>

                        <Flex style={{ textAlign: 'justify' }} flex={1}>
                            O boleto bancário é uma forma de pagamento prática e amplamente aceita. Após o pagamento, a compensação bancária e a identificação em nosso sistema podem levar de 1 a 3 dias úteis, conforme os prazos das instituições financeiras.

                            Por esse motivo, a liberação de serviços ou o prosseguimento da análise da solicitação ocorrerá somente após a confirmação do pagamento.

                            Se desejar maior agilidade na compensação e identificação do pagamento, recomendamos a utilização do PIX, que normalmente possui um prazo de confirmação menor do que o boleto bancário.
                        </Flex>

                        <Flex justify='center' align='center' flex={1} style={{ marginTop: 50 }}>
                            <Button size='large' icon={<DownloadOutlined />} onClick={async () => {
                                downloadArquivo(selected.boleto, selected.id, "ARTSOLBOLETO".concat(selected.id))
                            }}>Baixar Boleto</Button>
                        </Flex>

                    </Card>
                </Col>}
            </Row>
        </Modal>
        }


    </Flex>
}